import { Injectable } from '@angular/core';
import { Toolbox } from '../classes/toolbox';
import { ToolboxRead } from '../classes/toolbox-read';
import { ApiService } from './api/api.service';

@Injectable({
    providedIn: 'root',
})
export class ToolboxService {
    constructor(private apiService: ApiService) {}

    getToolboxes() {
        return this.apiService.getCall$<Toolbox[]>('toolbox');
    }

    deleteToolbox(id: number) {
        return this.apiService.deleteCall$(`toolbox/${id}`);
    }

    saveToolbox(toolbox: Toolbox) {
        return this.apiService.postCall$<Toolbox>('toolbox', toolbox);
    }

    getCurrentToolbox() {
        return this.apiService.getCall$<Toolbox>('toolbox/current');
    }

    readToolbox(toolboxId) {
        return this.apiService.getCall$<ToolboxRead>(`toolbox/read/${toolboxId}`);
    }

    readBy(toolboxId) {
        return this.apiService.getCall$<ToolboxRead[]>(`toolbox/read-by/${toolboxId}`);
    }
}
